import Icon from "@/components/icon";
import { ReportProgress } from "@/components/report/report-progress";

// Fast path: a single library read is sub-second, so a quiet inline loader —
// the full generation checklist would be dishonest there. Also used as the
// Suspense fallback for the code-split result view, so a not-yet-fetched chunk
// paints the same compact card instead of a blank gap.
export function InlineReportLoader() {
  return (
    <div
      role="status"
      className="flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-3 text-sm text-muted-foreground"
    >
      <Icon
        name="loader-circle"
        className="h-4 w-4 animate-spin"
        aria-hidden="true"
      />
      Wczytujemy raport…
    </div>
  );
}

interface SearchLoadingViewProps {
  // True while the query is still being resolved or the library fast path is
  // streaming (no drug_searches doc, no generation) — renders the quiet loader
  // instead of the phase checklist.
  fastPath: boolean;
  progress?: number;
  startedAt?: string;
  retrying: boolean;
  onRetry: () => void;
  onReportStuck: () => void;
}

// The loading view for an active search: quiet loader on the fast path, the
// full generation progress checklist for the backend flow.
export function SearchLoadingView({
  fastPath,
  progress,
  startedAt,
  retrying,
  onRetry,
  onReportStuck,
}: SearchLoadingViewProps) {
  if (fastPath) {
    return <InlineReportLoader />;
  }
  return (
    <ReportProgress
      progress={progress}
      startedAt={startedAt}
      onRetry={onRetry}
      onReportStuck={onReportStuck}
      retrying={retrying}
    />
  );
}
